export default __webpack_public_path__ + "static/media/paper.49f8b1fd.svg";